import Record from "../../../server/mate/Record";
import { getFocusItem } from "../../share-document";
import { getCurrentConference, getRoomOption } from "../conference";
import { StateListenerRegistry } from "../redux";
import { getAudioTrackInGroup } from "../tracks";
import { setCanvasProperty } from "./action";
import RecordWorker from "./record.worker";

const recordWorker = new RecordWorker();

let messageCount  = 0;
let recorder;
let isStoppedRecording = true;
let canvas_t;
let stream_t;

StateListenerRegistry.register(
    state => getAudioTrackInGroup(state, true), 
    (audioTracks, {getState}) => {
        const record = getState()["features/base/canvas"].record;
        if (record) {
            const tracks = new Map();
            audioTracks.map(t => tracks.set(t.track.stream.id, t.track));

            fileRecord && fileRecord.connectAudio(tracks);
        }
    }, {
        deepEquals: true
    });

StateListenerRegistry.register(state => getCurrentConference(state),
    (conference, store) => {
        if (!conference) {
            const record = store.getState()["features/base/canvas"].record;
            if (record) {
                store.dispatch(setCanvasProperty({ record: false }));
            }
        }
    }
)

StateListenerRegistry.register(state => state['features/screen-share'].sharingVideo,
    async (sharingVideo, store) => {
        const record = store.getState()["features/base/canvas"].record;
        if (record) {
            const sleep = m => new Promise(r => setTimeout(r, m));
            await sleep(1000);
        }
    });

StateListenerRegistry.register(state => getFocusItem(state),
    async (focusItem, store) => {
        const record = store.getState()["features/base/canvas"].record;
        if (record) {
            const sleep = m => new Promise(r => setTimeout(r, m));
            await sleep(1000);
        }
    });

StateListenerRegistry.register(state => state['features/video-layout-mode'].layoutWidth,
    (layoutWidth, store) => {
        const record = store.getState()["features/base/canvas"].record;
        if (record) {
            const elementToRecord = document.getElementById("canvas_container");

            if (elementToRecord) {
                canvas_t.width = elementToRecord.clientWidth;
                canvas_t.height = elementToRecord.clientHeight;
            }   
        }        
    });


StateListenerRegistry.register(state => state["features/base/canvas"].record,
    async (record, { getState, dispatch }) => {
        if (record) {         
            const conference = getCurrentConference(getState());
            if (conference !== true) return; 
            
            if (!fileRecord.isSupportedBrowser()) {
                fileRecord.stopRecord();
                dispatch(setCanvasProperty({record: false}));
                alert("녹화를 지원하지 않는 브라우저입니다.");
                return;
            }

            
            recordWorker.postMessage({ run: true });

            recordWorker.onmessage = event => {              
                if (event.data.message) drawCanvas();
            }
        
            const elementToRecord = document.getElementById("canvas_container");

            const canvas = document.createElement("canvas");
            
            canvas.width = elementToRecord.clientWidth > 1920 ? elementToRecord.clientWidth : 1920;
            canvas.height = elementToRecord.clientHeight > 1280 ? elementToRecord.clientHeight : 1280;

            isStoppedRecording = false;
            const stream = canvas.captureStream();
            stream.fullcanvas = true;
            stream.width = elementToRecord.clientWidth;
            stream.height = elementToRecord.clientHeight;

            canvas_t = canvas;
            stream_t = stream;
            
            const audioTracks = new Map();
            getAudioTrackInGroup(getState(), true).map(t => audioTracks.set(t.track.stream.id, t.track));
            
            // audio load 
            fileRecord.loadAudioStraem(audioTracks);

            fileRecord.startRecord(stream);
        } else {
            fileRecord.stopRecord();
            recordWorker.postMessage({ run: false });
        }
    }
);

class FileRecord {
    constructor() {
        this.storage;
        this.stream = new Map();
        this.gdmStream;
        this.audioSource;

        const record = new Record();        
        this.record = record;
    }

    // 녹화 가능 브라우저 
    isSupportedBrowser() {
        
        if ( this.audioContext === undefined ) return false;
        if ( navigator.mediaDevices === undefined || navigator.mediaDevices.getDisplayMedia === undefined ) return false;
        if ( typeof MediaRecorder === undefined ) return false;
        
        return true;
    }

    init() {
        const audioContext = window.AudioContext;
        if (typeof audioContext === undefined) {
            if (typeof window.webkitAudioContext !== undefined) {
                /*global AudioContext:true */
                audioContext = window.webkitAudioContext;
            }

            if (typeof window.mozAudioContext !== undefined) {
                /*global AudioContext:true */
                audioContext = window.mozAudioContext;
            }
        }

        this.audioContext = audioContext;

        this.storage = {
            AudioContext: null,
            AudioContextConstructor: null
        };

        if (typeof audioContext !== undefined) this.storage.AudioContext = audioContext;
        else if (typeof window.webkitAudioContext !== undefined) this.storage.AudioContext = window.webkitAudioContext;

        const handler = {
            start: this.start.bind(this),
            stop: this.stop.bind(this),
            save: (data) => this.save(data)
        };
        this.record.init(handler);
    }

    // 녹화 시작 
    async startRecord(stream) {
        this.gdmStream = null;
        try {
            this.gdmStream = stream;
    
            var mixedAudioStream = this.getMixedAudioStream();
            
            var mixTracks = mixedAudioStream.getTracks().concat(this.gdmStream.getVideoTracks());
            var resultStream = new MediaStream(mixTracks);

            this.record.start(resultStream);

            this.gdmStream && this.gdmStream.addEventListener('inactive', () => this.record.stop() );            
        } catch (e) { 
            console.log(e)
        
            this.stop();
        }        
    }

    stopRecord() {
        this.record.stop();
    }

    start() {
        console.log("start");
        // drawCanvas();
    }

    stop() {     
        console.log("stop");
        if (this.gdmStream) {
            const filename = this.getFileName();
            this.record.getSaveFile(filename);
        }


        this.gdmStream && this.gdmStream.getTracks().forEach(track => track.stop());
        this.gdmStream = null;
    }

    save(data) {
        // console.log(data)
    }

    getFileName() {
        const now = new Date();
        const timestamp = now.toISOString();
        const roomName = decodeURIComponent(getRoomOption(APP.store.getState()).name);

        if (roomName)
            return `${roomName}_${timestamp}`;
        else
            return `recording_${timestamp}`;
    }


    loadAudioStraem(audioTrack) {
        if (!this.storage.AudioContextConstructor) {
            this.storage.AudioContextConstructor = new this.storage.AudioContext();
        }

        this.audioContext = this.storage.AudioContextConstructor;
        this.audioSources = [];
        
        this.gainNode = this.audioContext.createGain();
        this.gainNode.connect(this.audioContext.destination);
        this.gainNode.gain.value = 0;

        this.audioDestination = this.audioContext.createMediaStreamDestination();

        audioTrack.forEach(track => {
            const stream = track.stream;

            if (stream) {
                var audioSource = this.audioContext.createMediaStreamSource(stream);
                audioSource.connect(this.gainNode);

                this.audioSources.push(audioSource);

                this.stream.set(stream.id, track);
            }            
        });
    }   
    
    getMixedAudioStream() {
        this.audioSources.forEach((audioSource) => {
            audioSource.connect(this.audioDestination);
        });
            
        return this.audioDestination.stream;
    }

    connectAudio(audioTracks) {
        // 녹화중인지 확인 
        if (this.record && this.record.isRecording()) {
            let list = new Array();
            if (this.stream.size > audioTracks.size) {
                this.stream.forEach((t, streamId) => {
                    if (audioTracks.has(streamId)) return;
                    list.push(streamId);
                });

                list.map(streamId => {
                    const idx = this.audioSources.findIndex((source, id) => id == streamId);
                    if (idx > -1) {
                        this.audioSources[idx].disconnect();
                        this.audioSources.splice(idx, 1);
                    }
                });                
            } else {
                audioTracks.forEach((t, streamId) => {
                    if (this.stream.has(streamId)) return;
                    list.push(t);
                });

                list.map(t => {
                    const stream = t.stream;
                    var audioSource = this.audioContext.createMediaStreamSource(stream);
                    audioSource.connect(this.gainNode);
            
                    this.audioSources.push(audioSource);
                    audioSource.connect(this.audioDestination);
                });  
            }
        }
    }

}

const drawCanvas = () => {
    if (isStoppedRecording) return;
    const elementToRecord = document.getElementById("canvas_container");
    const ctx = canvas_t.getContext("2d");
    if (!elementToRecord) return;

    const { width: canvasWidth, height: canvasHeight } = canvas_t;
    const screenFilm = document.getElementById("screenFilm");
    if (screenFilm) {    
        const video = screenFilm.getElementsByTagName("video")[0];
        ctx.clearRect(0, 0, canvasWidth, canvasHeight);
        ctx.fillStyle = "#000";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        
        const { clientWidth: viedoWidth, clientHeight: videoHeight } = video;
        let width, height;
        if (viedoWidth > videoHeight) {
            width = canvasWidth;
            height = videoHeight * (width / viedoWidth);
        } 
        if (height > canvasHeight) {
            height = canvasHeight;
            width = viedoWidth * (height / videoHeight);
        }
        canvas_t.getContext("2d").drawImage(video, (canvasWidth - width) / 2, (canvasHeight - height) / 2, width, height);
        return;
    }        

    const canvasElement = elementToRecord.getElementsByTagName("canvas");
    if (canvasElement.length > 0) {
        ctx.clearRect(0, 0, canvasWidth, canvasHeight);
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
                
        for (let i = 0; i < canvasElement.length; i++) {
            let canvas = canvasElement[i];

            let initWidth, initHeight;

            const canvsStyle = canvas.getBoundingClientRect();
            
            initWidth = canvsStyle.width;
            initHeight = canvsStyle.height;
            // }
        
            let width =  initWidth, height = initHeight;
            if (initWidth > initHeight) {
                width = canvasWidth;
                height = initHeight * (width / initWidth);
            } 
            if (height > canvasHeight) {
                height = canvasHeight;
                width = initWidth * (height / initHeight);
            }

            const x = canvasWidth - width > 0 ? (canvasWidth - width) / 2 : 0;
            const y = canvasHeight - height > 0 ? (canvasHeight - height) / 2 : 0
            canvas_t.getContext("2d").drawImage(canvas, x, y, width, height);
        }            
    } else {
        ctx.clearRect(0, 0,  canvasWidth, canvasHeight);
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        const canvas = defaultCanvas(canvasWidth, canvasHeight);

        ctx.drawImage(canvas, 0, 0, canvasWidth, canvasHeight);
    }
}

const defaultCanvas = (canvasWidth, canvasHeight) => {
    const elementToRecord = document.getElementById("canvas_container");
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = canvas_t.width;
    canvas.height = canvas_t.height;
    
    ctx.fillStyle = "#000";
    ctx.font = "bold 48px verdana, sans-serif ";

    ctx.textAlign="center";
    ctx.fillText('화면 이동 중 입니다.', canvasWidth / 2, canvasHeight / 2);

    return canvas;
}

const fileRecord = new FileRecord();
fileRecord.init();